import { useSessionStorage } from 'support/react/hooks';

/**
 * Custom parameters for clients to enrich events sent to their webhook integrations
 *
 * See: https://docs.instruqt.com/how-to-guides/integrate-external-systems/embed-a-track#embed-custom-parameters
 */
export const useCustomParameters = () => {
  return useSessionStorage<{ [k: string]: string }>('instruqt_custom_parameters');
};
